import { render, staticRenderFns } from "./Recomendados.vue?vue&type=template&id=43d2b218"
import script from "./Recomendados.vue?vue&type=script&lang=js"
export * from "./Recomendados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports